module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidemenu"
  }, [(this.$store.state.core.user) ? _c('ul', {
    staticClass: "uk-list"
  }, [(_vm.$store.state.core.user.role >= 4) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/configuratie"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: cog"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-visible@m"
  }, [_vm._v("Configuratie")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.core.user.role >= 3) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: users"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-visible@m"
  }, [_vm._v("Gebruikers")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/media"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-visible@m"
  }, [_vm._v("Gallerij")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pages"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: copy"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-visible@m"
  }, [_vm._v("Pagina's")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: bolt"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-visible@m"
  }, [_vm._v("Projects")])])], 1)]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "bottom-logo",
    attrs: {
      "src": require("../assets/logo_white_solo.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bottom-version"
  }, [_vm._v(_vm._s(_vm.$store.state.core.version))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ed6eab4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CUSTOM/components/SideMenu.vue
// module id = 518
// module chunks = 1